const setings = state => state.setings;
const examList = state => state.examList;
const examCategoryList = state => state.examCategoryList;
const articleList = state => state.articleList;

export default {
  setings,
  examList,
  examCategoryList,
  articleList
};
